import { DISMISS_CHANGELOG } from "@lib/graphql/mutations";
import { UNSEEN_CHANGELOG_ENTRIES_QUERY } from "@lib/graphql/queries";
import { useState } from "react";
import { useMutation, useQuery } from "urql";
import { ChangelogModal } from "./ChangelogModal";

export function ChangelogPopup() {
  const [dismissed, setDismissed] = useState(false);
  const [{ data }] = useQuery({ query: UNSEEN_CHANGELOG_ENTRIES_QUERY });
  const [, dismissChangelog] = useMutation(DISMISS_CHANGELOG);

  const entries = data?.unseenChangelogEntries ?? [];

  if (dismissed || entries.length === 0) return null;

  const handleDismiss = async () => {
    setDismissed(true);
    await dismissChangelog({ input: {} });
  };

  return <ChangelogModal entries={entries} onClose={handleDismiss} />;
}
